import {Component, OnInit } from '@angular/core';
import {Board} from '../../../model';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BoardProvider} from 'src/app/providers';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {SystemType} from '../../../model/enums/system.type';
import {ModeService} from '../../../services';

@Component({
  selector: 'create-new-board-modal',
  templateUrl: './create-new-board.modal.html',
  styleUrls: ['./create-new-board.modal.scss']
})
export class CreateNewBoardModal implements OnInit {
  subject: Subject<Board>;
  isEdit = false;
  board: Board = new Board();
  errMsg = null;
  currentMode: SystemType;
  modeSub: any;
  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private boardProvider: BoardProvider,
    private modeService: ModeService
  ) { }

  ngOnInit(): void {
    this.modeSub = this.modeService.mode$.subscribe(mode => {
      if(mode){
        this.currentMode = mode;
      }
    });
  }

  ngOnDestroy(): void {
    if(this.modeSub) this.modeSub.unsubscribe();
  }
  onSubmit(): void {
    this.errMsg = null;
    this.board.TYPE = this.currentMode;
    this.boardProvider.saveBoard(this.board)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next(Board.parse(data.result));
          } else {
            this.errMsg = data.error.txt;
            setTimeout(() => {
              this.errMsg = null;
            }, 3000);
          }
        });
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }
}
